import { ArrangementCase, MonarchStatementDraft } from "../types";

export function buildMonarchStatementDraft(arrangementCase: ArrangementCase): MonarchStatementDraft {
  return {
    ...arrangementCase.paperwork,
    lovedOneName: formatFullName(
      arrangementCase.decedent.firstName,
      arrangementCase.decedent.middleName,
      arrangementCase.decedent.lastName,
    ),
    purchaserName: formatFullName(arrangementCase.planner.firstName, undefined, arrangementCase.planner.lastName),
    purchaserPhone: arrangementCase.planner.phone,
    purchaserEmail: arrangementCase.planner.email,
  };
}

export function paperworkCompletionLabel(draft: MonarchStatementDraft): string {
  if (draft.missingFields.length === 0) return "Ready for signature";
  if (draft.missingFields.length === 1) return "1 field needs review";
  return `${draft.missingFields.length} fields need review`;
}

function formatFullName(firstName: string, middleName: string | undefined, lastName: string): string {
  return [firstName, middleName, lastName].filter(Boolean).join(" ");
}
